import { useEffect } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  .return-page { font-family:'DM Sans',sans-serif; background:#f8f6f0; min-height:100vh; color:#1a1a2e; }

  .return-hero {
    background:linear-gradient(135deg,#2d1b69 0%,#4a1c8c 50%,#7b2d8b 100%);
    padding:80px 40px 60px; position:relative; overflow:hidden;
  }
  .return-hero::before {
    content:''; position:absolute; top:-20%; right:-5%; width:400px; height:400px;
    background:radial-gradient(circle,rgba(255,107,107,0.12) 0%,transparent 70%); border-radius:50%;
  }
  .return-hero::after {
    content:''; position:absolute; bottom:0; left:0; right:0; height:4px;
    background:linear-gradient(90deg,#ff6b6b,#feca57,#ff6b6b);
  }
  .brand-badge { display:inline-flex; align-items:center; gap:10px; background:rgba(255,107,107,0.12); border:1px solid rgba(255,107,107,0.3); padding:8px 20px; border-radius:50px; margin-bottom:24px; }
  .brand-dot { width:8px; height:8px; background:#ff6b6b; border-radius:50%; animation:pulse 2s infinite; }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(0.8)} }
  .brand-name { color:#ff6b6b; font-size:13px; font-weight:600; letter-spacing:2px; text-transform:uppercase; }
  .return-hero h1 { font-family:'Playfair Display',serif; font-size:clamp(36px,5vw,56px); font-weight:800; color:#fff; margin:0 0 16px; line-height:1.1; }
  .return-hero p { color:rgba(255,255,255,0.6); font-size:15px; max-width:500px; }
  .policy-meta { display:flex; gap:16px; margin-top:32px; flex-wrap:wrap; }
  .meta-chip { background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.15); padding:6px 16px; border-radius:6px; color:rgba(255,255,255,0.75); font-size:12px; font-weight:500; }

  .policy-body { max-width:860px; margin:0 auto; padding:60px 40px; }

  .eligibility-timeline { display:flex; margin-bottom:48px; background:#fff; border:1px solid #e8e4da; border-radius:16px; overflow:hidden; box-shadow:0 2px 12px rgba(0,0,0,0.04); }
  .timeline-step { flex:1; padding:28px 16px; text-align:center; position:relative; }
  .timeline-step:not(:last-child)::after { content:'→'; position:absolute; right:-8px; top:50%; transform:translateY(-50%); color:#ccc; font-size:20px; z-index:1; }
  .timeline-step.active { background:linear-gradient(135deg,#2d1b69,#4a1c8c); }
  .timeline-step.active .step-day { color:#feca57; }
  .timeline-step.active .step-label, .timeline-step.active .step-desc { color:white; }
  .step-day { font-family:'Playfair Display',serif; font-size:26px; font-weight:800; color:#2d1b69; margin-bottom:4px; }
  .step-label { font-size:11px; font-weight:600; color:#1a1a2e; text-transform:uppercase; letter-spacing:1px; margin-bottom:6px; }
  .step-desc { font-size:11px; color:#888; line-height:1.4; }

  .two-col { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:24px; }
  .mini-card { background:#fff; border:1px solid #e8e4da; border-radius:12px; padding:24px; box-shadow:0 2px 8px rgba(0,0,0,0.04); }
  .mini-card h3 { font-family:'Playfair Display',serif; font-size:17px; margin:0 0 16px; }
  .mini-card.eligible-card { border-top:3px solid #2ed573; }
  .mini-card.eligible-card h3 { color:#0f7a3c; }
  .mini-card.not-eligible-card { border-top:3px solid #ff6b6b; }
  .mini-card.not-eligible-card h3 { color:#c0392b; }

  .eligible-list, .not-eligible-list { list-style:none; padding:0; margin:12px 0; }
  .eligible-list li, .not-eligible-list li { display:flex; align-items:flex-start; gap:10px; padding:8px 0; border-bottom:1px solid #f0ece4; font-size:13px; }
  .eligible-list li:last-child, .not-eligible-list li:last-child { border-bottom:none; }
  .yes-icon { color:#2ed573; font-weight:bold; flex-shrink:0; }
  .no-icon { color:#ff6b6b; font-weight:bold; flex-shrink:0; }

  .section-card { background:#fff; border:1px solid #e8e4da; border-radius:16px; overflow:hidden; margin-bottom:24px; box-shadow:0 2px 12px rgba(0,0,0,0.04); }
  .section-card-header { background:linear-gradient(135deg,#2d1b69,#4a1c8c); padding:20px 28px; display:flex; align-items:center; gap:14px; }
  .section-icon { font-size:22px; }
  .section-card-header h2 { font-family:'Playfair Display',serif; font-size:20px; font-weight:700; color:#fff; margin:0; }
  .section-card-body { padding:28px; font-size:15px; line-height:1.8; color:#3a3a50; }
  .section-card-body p { margin:0 0 14px; } .section-card-body p:last-child { margin:0; }

  .steps-list { counter-reset:steps; list-style:none; padding:0; margin:12px 0; }
  .steps-list li { display:flex; align-items:flex-start; gap:14px; padding:14px 0; border-bottom:1px solid #f0ece4; font-size:14px; }
  .steps-list li:last-child { border-bottom:none; }
  .step-num { width:28px; height:28px; background:linear-gradient(135deg,#2d1b69,#4a1c8c); color:#feca57; font-size:13px; font-weight:700; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0; }

  .info-list { list-style:none; padding:0; margin:12px 0; }
  .info-list li { display:flex; align-items:flex-start; gap:10px; padding:10px 0; border-bottom:1px solid #f0ece4; font-size:14px; }
  .info-list li:last-child { border-bottom:none; }
  .check-icon { color:#2ed573; font-weight:bold; flex-shrink:0; margin-top:2px; }

  .highlight-purple { background:linear-gradient(135deg,#f5f0ff,#ede8ff); border-left:4px solid #7b2d8b; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }
  .highlight-red { background:linear-gradient(135deg,#fff5f5,#ffe8e8); border-left:4px solid #ff6b6b; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }

  .contact-card { background:linear-gradient(135deg,#2d1b69,#7b2d8b); border-radius:16px; padding:36px; text-align:center; margin-top:48px; color:white; }
  .contact-card h3 { font-family:'Playfair Display',serif; font-size:24px; margin:0 0 12px; color:#feca57; }
  .contact-card p { color:rgba(255,255,255,0.7); margin:0 0 24px; font-size:14px; }
  .contact-links { display:flex; justify-content:center; gap:16px; flex-wrap:wrap; }
  .contact-link { background:rgba(254,202,87,0.15); border:1px solid rgba(254,202,87,0.4); color:#feca57; padding:10px 24px; border-radius:8px; text-decoration:none; font-size:14px; font-weight:500; transition:all 0.2s; }
  .contact-link:hover { background:#feca57; color:#2d1b69; }

  @media(max-width:600px) {
    .return-hero{padding:60px 20px 40px} .policy-body{padding:40px 20px}
    .eligibility-timeline{flex-direction:column} .two-col{grid-template-columns:1fr} .section-card-body{padding:20px}
    .timeline-step:not(:last-child)::after{content:'↓';right:50%;top:auto;bottom:-12px;transform:translateX(50%)}
  }
`;

export default function ReturnRefundPolicy() {
  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div className="return-page">
      <div className="return-hero">
        <div className="brand-badge"><div className="brand-dot" /><span className="brand-name">ITI Expert Guruji</span></div>
        <h1>Return & Refund Policy</h1>
        <p>Shop with confidence — our fair refund policy is always on your side.</p>
        <div className="policy-meta">
          <span className="meta-chip">📅 Effective: January 1, 2025</span>
          <span className="meta-chip">⏱ 7–14 Day Refund Window</span>
          <span className="meta-chip">🛡 Student-Friendly</span>
        </div>
      </div>

      <div className="policy-body">
        <div className="eligibility-timeline">
          <div className="timeline-step active">
            <div className="step-day">D+0</div>
            <div className="step-label">Purchase</div>
            <div className="step-desc">Payment successful, access begins</div>
          </div>
          <div className="timeline-step">
            <div className="step-day">D+7</div>
            <div className="step-label">Refund Window</div>
            <div className="step-desc">Last date to raise a refund request</div>
          </div>
          <div className="timeline-step">
            <div className="step-day">D+14</div>
            <div className="step-label">Processing</div>
            <div className="step-desc">Refund review & approval</div>
          </div>
          <div className="timeline-step">
            <div className="step-day">D+21</div>
            <div className="step-label">Credited</div>
            <div className="step-desc">Amount back in your account</div>
          </div>
        </div>

        <div className="two-col">
          <div className="mini-card eligible-card">
            <h3>✅ Eligible for Refund</h3>
            <ul className="eligible-list">
              <li><span className="yes-icon">✓</span> Request raised within 7 days of purchase</li>
              <li><span className="yes-icon">✓</span> Course content unavailable or not working</li>
              <li><span className="yes-icon">✓</span> Double charge occurred — full amount refunded</li>
              <li><span className="yes-icon">✓</span> Content does not match course description</li>
              <li><span className="yes-icon">✓</span> No access due to a technical error on our end</li>
            </ul>
          </div>
          <div className="mini-card not-eligible-card">
            <h3>❌ Not Eligible for Refund</h3>
            <ul className="not-eligible-list">
              <li><span className="no-icon">✗</span> Request raised after 7 days of purchase</li>
              <li><span className="no-icon">✗</span> More than 50% of course content consumed</li>
              <li><span className="no-icon">✗</span> Certificate has been downloaded</li>
              <li><span className="no-icon">✗</span> Live class was attended</li>
              <li><span className="no-icon">✗</span> Mock test papers have been downloaded</li>
            </ul>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">📋</span><h2>How to Request a Refund</h2></div>
          <div className="section-card-body">
            <ol className="steps-list">
              <li><div className="step-num">1</div><div>Log in to your ITI Expert Guruji account and navigate to "My Purchases"</div></li>
              <li><div className="step-num">2</div><div>Select the relevant course and click the "Request Refund" button</div></li>
              <li><div className="step-num">3</div><div>Select a reason for refund and add a brief description (optional)</div></li>
              <li><div className="step-num">4</div><div>After submission, you will receive a confirmation email within 24 hours</div></li>
              <li><div className="step-num">5</div><div>Our team will review your request within 2–3 business days</div></li>
              <li><div className="step-num">6</div><div>Once approved, the amount will be credited within 5–7 business days</div></li>
            </ol>
            <div className="highlight-purple"><strong>💡 Tip:</strong> If the online process is unavailable, email us at msmahajan79@gmail.com with your Order ID.</div>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">💳</span><h2>Where Will the Refund Be Credited?</h2></div>
          <div className="section-card-body">
            <ul className="info-list">
              <li><span className="check-icon">✓</span><strong>Credit/Debit Card:</strong>&nbsp; Back to original card within 5–7 business days</li>
              <li><span className="check-icon">✓</span><strong>UPI / Net Banking:</strong>&nbsp; Back to source account within 3–5 business days</li>
              <li><span className="check-icon">✓</span><strong>Wallet:</strong>&nbsp; Back to the same wallet within 2–3 business days</li>
              <li><span className="check-icon">✓</span><strong>ITI Expert Guruji Credits:</strong>&nbsp; Instant — usable for future purchases (with 10% bonus)</li>
            </ul>
            <div className="highlight-purple"><strong>💡 ITI Expert Guruji Credits Option:</strong> Choose ITI Expert Guruji Credits instead of a cash refund and receive 10% extra! e.g. ₹500 refund = ₹550 in credits.</div>
          </div>
        </div>

        <div className="section-card">
          <div className="section-card-header"><span className="section-icon">⚠️</span><h2>Special Cases</h2></div>
          <div className="section-card-body">
            <p><strong>Course Discontinued:</strong> If ITI Expert Guruji discontinues a course, a full refund will be issued regardless of the 7-day window.</p>
            <p><strong>Technical Issues:</strong> If a platform-side technical issue prevented course access, a full refund or extended access will be provided.</p>
            <p><strong>School / Group Purchases:</strong> Institutional purchases are governed by a separate refund policy as per the contract terms.</p>
            <div className="highlight-red"><strong>⚠️ Note:</strong> Refund policy does not apply to promotional offers, flash sales, or free trial courses.</div>
          </div>
        </div>

        <div className="contact-card">
          <h3>Need Help with a Refund?</h3>
          <p>Our support team is available Monday to Saturday, 9 AM – 6 PM</p>
          <div className="contact-links">
            <a href="mailto:msmahajan79@gmail.com" className="contact-link">✉ msmahajan79@gmail.com</a>
            <a href="tel:+91 9421989575" className="contact-link">📞 +91  9421989575</a>
          </div>
        </div>
      </div>
    </div>
  );
}
